/**
 * AWS Spend Hook
 * TanStack Query hook for fetching AWS Cost Explorer billing data
 */

import { useQuery } from '@tanstack/react-query';
import { getAwsSpend } from '../api';

/** Query key factory */
export const awsSpendKeys = {
  all: ['aws-spend'] as const,
  summary: () => [...awsSpendKeys.all, 'summary'] as const,
};

/**
 * Hook to fetch AWS spend data
 * Refreshes every 5 minutes
 */
export function useAwsSpend() {
  return useQuery({
    queryKey: awsSpendKeys.summary(),
    queryFn: getAwsSpend,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 5 * 60 * 1000, // Auto-refresh every 5 minutes
  });
}
